
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Boostez votre référencement avec les données structurées",
    description:
      "Découvrez comment utiliser les données structurées pour améliorer votre SEO. Suivez nos conseils pour optimiser votre site et augmenter sa visibilité en ligne.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
